/**
 * WebCore ValidationResult 兼容 PascalCase / camelCase。
 */
function toMessageList(value) {
  if (!value) {
    return [];
  }
  if (Array.isArray(value)) {
    return value.filter(Boolean).map(String);
  }
  if (typeof value === 'string' && value.trim()) {
    return [value.trim()];
  }
  return [];
}

export function resolveApiErrorMessage(res, fallback = '') {
  const fromSystem = toMessageList(res?.systemErrorMsg ?? res?.SystemErrorMsg);
  const fromMsg = toMessageList(res?.msg ?? res?.Msg);
  const fromData = typeof res?.data === 'string' && res.data.trim() ? [res.data.trim()] : [];
  const parts = [...fromSystem, ...fromMsg, ...fromData];
  return parts.length ? parts.join(' ') : fallback;
}

export function normalizeApiResponse(res) {
  if (!res || typeof res !== 'object') {
    return { isSuccessful: false, data: null, msg: '', raw: res };
  }

  let data = res.data ?? res.Data ?? null;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      /* keep string */
    }
  }

  return {
    isSuccessful: !!(res.isSuccessful ?? res.IsSuccessful),
    data,
    msg: res.msg ?? res.Msg ?? '',
    systemErrorMsg: res.systemErrorMsg ?? res.SystemErrorMsg ?? [],
    code: res.code ?? res.Code ?? '',
    statusCode: res.statusCode ?? res.StatusCode ?? null,
    raw: res,
  };
}
